/**
 * UI Constants for Office Arena
 * Centralized location for magic numbers, timeouts, and design tokens
 */

// Timing Constants
export const TIMEOUTS = {
  HEIGHT_UPDATE_FAST: 50,
  HEIGHT_UPDATE_MEDIUM: 200,
  HEIGHT_UPDATE_SLOW: 500,
  RESIZE_OBSERVER_DELAY: 10,
};

// Layout Constants
export const LAYOUT = {
  CARD_MIN_HEIGHT: 400,
  MAX_DISPLAYED_MATCHES_DEFAULT: 30,
  NAVBAR_HEIGHT: 16,
  STATS_CARD_HEIGHT: 32,
};

// Text Lengths
export const TEXT_LIMITS = {
  MAX_LINE_LENGTH: 80,
  MAX_FUNCTION_LENGTH: 20,
  MAX_FILE_LENGTH: 200,
};

// Chart Constants
export const CHART = {
  TREND_CHART_HEIGHT: 48, // h-48 in Tailwind (12rem)
};

// TrueSkill Display Constants
export const TRUESKILL = {
  CONSERVATIVE_MULTIPLIER: 3,
  DISPLAY_DECIMAL_PLACES: 2,
};

// Bread Calculation Constants
export const BREAD = {
  FULL_SLICE_VALUE: 1.0,
  HALF_SLICE_VALUE: 0.5,
  FULL_SLICE_MULTIPLIER: 2,
};

// Tab Names
export const TABS = {
  LEADERBOARD: 'leaderboard',
  BREAD: 'bread',
  MATCHES: 'matches',
  ANALYTICS: 'analytics',
};

// Team Colors
export const TEAM_COLORS = {
  TEAM1: '#18181b', // zinc-900 (Black team)
  TEAM2: '#f4f4f5', // zinc-100 (White team)
};

// Filter Options
export const FILTER_OPTIONS = {
  ALL: 'all',
  WINS: 'wins',
  LOSSES: 'losses',
  FULL: 'full',
  HALF: 'half',
  NONE: 'none',
};

// CSS Classes (commonly used)
export const CSS_CLASSES = {
  HOVER_TRANSITION: 'hover:border-zinc-300 transition-colors',
  TEXT_SMALL_BOLD: 'text-xs font-bold uppercase tracking-widest',
  BUTTON_HOVER: 'hover:text-indigo-600 transition-colors cursor-pointer',
  CARD_PADDING: 'p-6',
};

// Environment Detection
export const ENV_KEYS = {
  USE_MOCK_DATA: 'REACT_APP_USE_MOCK_DATA',
  USE_LOCALSTACK: 'REACT_APP_USE_LOCALSTACK',
  AWS_REGION: 'REACT_APP_AWS_REGION',
  S3_BUCKET: 'REACT_APP_S3_BUCKET',
  AUTH0_DOMAIN: 'REACT_APP_AUTH0_DOMAIN',
  AUTH0_CLIENT_ID: 'REACT_APP_AUTH0_CLIENT_ID',
  AUTH0_AUDIENCE: 'REACT_APP_AUTH0_AUDIENCE',
  API_BASE_URL: 'REACT_APP_API_BASE_URL',
};
